import React from 'react';
import PropTypes from 'prop-types';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalSeasonSelector.scss';
import {
    Grid,
    Row,
    cls,
    Keyboard,
    Form,
    Column,
    ColoredButton,
    FormInput,
    Button,
    HeaderCompound,
} from '../../packages/components';
import Translator from '../../requests/apa/Translator';
import Asset from 'src/requests/apa/Asset';
import Ribbon from '../../components/Ribbon';
import Device from '../../devices/device';
import Utils from "../../utils/Utils";

const MAIN_CLASSNAME = 'aaf-modal-season-selector';

class ModalSeasonSelector extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.closeModal =this.closeModal.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.keys = Device.getDevice().getKeys();
    }

    closeModal(){
        const { handleClose = ()=>{} } = this.props;
        handleClose();
    }

    parseSeasonItems(seasons = []){
        const { changeContent = ()=>{} } = this.props;
        return seasons.map(season => {
            const {
                groupId = '',
                title = '',
                image_large = '',
                first_episode = null,
                number = ''
            } = season;
            return {
                id: groupId,
                title: `${Translator.get('_','Temporada')} ${number}`,
                group_id: groupId,
                cover: image_large,
                format_types: [],
                live_enabled: false,
                type: 'vod',
                provider: 'amco',
                clickHandler: () => {
                    if(first_episode){
                        this.closeModal();
                        changeContent(first_episode, season);
                    }
                }
            };
        })
    }

    componentDidMount(){
        this.removeEventListener();
        this.addEventListener();
        //Foco primer elemento
        Utils.setInitialFocusChangeTime("#temporada_link_1", 0)
    }

    componentWillUnmount(){
        this.removeEventListener();
    }

    handleKeyDown(e){
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if(currentKey === 'YELLOW'){
            this.closeModal();
        }
    }

    addEventListener(){
        document.addEventListener('keydown', this.handleKeyDown);
    }

    removeEventListener(){
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    render() {
        const { serieData = null, user = {}, serieTitle = '' } = this.props;
        const { seasons  = [] } = serieData || {};
        const modalProps = {
            childrenClassName: `${MAIN_CLASSNAME}-wrapper`,
        };
        return (
            <ModalWrapper {...modalProps}>
                <Grid className={cls(`${MAIN_CLASSNAME}`)}>
                    <HeaderCompound
                        disabled
                        align='right'
                        onClick={this.closeModal}
                        textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                        icon={`${Asset.get('top_head_option_back')}`}/>
                        <div
                            className={`${MAIN_CLASSNAME}-ribbon-wrapper`}>
                            <span className="serie-title">
                                {serieTitle}
                            </span>
                            <div className="special-ribbon-carousel">
                                <Ribbon
                                    variant={'modal-season-selector'}
                                    user={user}
                                    type="landscape"
                                    items={this.parseSeasonItems(seasons)}
                                    setMetricsEvent={()=>{}}
                                    hideTitles = {true}
                                    modalSeasons={true}
                                    visibleNumber={3}
                                    isSesion = {true}
                                    />
                            </div>
                        </div>
                </Grid>
            </ModalWrapper>
        );
    }
}

ModalSeasonSelector.defaultProps = {
    serieTitle: '',
    serieData: null,
    user: null,
    changeContent: ()=>{}
};

ModalSeasonSelector.propTypes = {
    serieTitle: PropTypes.string.isRequired,
    serieData: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    changeContent: PropTypes.func.isRequired
};

export default withOnClose(ModalSeasonSelector);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalSeasonSelector.jsx